import Vue from "vue";

export default {
	state: {
		banks: []
	},
	mutations: {
		setBanksOnState(state, banks) {
			state.banks = banks;
		}
	},
	actions: {
		getBanks({ commit }) {
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.get("bank")
					.then((response) => {
						this.state.loading = false;
						commit("setBanksOnState", response.data.data);
						resolve(response.data.data);
					})
					.catch(() => {
						this.state.loading = false;
						reject();
					});
			});
		}
	},
	getters: {
		banks({ banks }) {
			return banks;
		}
	}
};
